import {Component, OnInit} from '@angular/core';

// Services
import {AppService} from './shared/services/app-service';
import {AppCatalogService} from './catalog/shared/services/app-catalog-service';
import {ProductCategoriesMockApi} from './catalog/shared/services/mock-product-categories-api';
import {ProductsMockApi} from './catalog/shared/services/mock-products-api';
import {NavigationService} from './shared/services/navigation-service';
import {LogsService} from './shared/services/logs-service';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:AppCmp'));

/**
 * Main app component.
 * `appService.init()` start loading the app data.
 * <!> Current implementation does not have a real web API to connect to.
 *     A mock api was implemented to allow implementation of api calls as if a server was present.
 *     Injecting the mock APIs is enough to get them ready to listen for api calls.
 *     TODO: Remove mock api after implementing a real web api
 * <!> Due to insufficient time, current application is missing interfaces all over the place, thus making limited use of typescript
 *     TODO: A good introductory task for the developers who will maintain this project is to implement all the missing interfaces while keeping the app functioning.
 * <!> Again, due to insufficient time, a significant part of the application is not implementing ngrx properly.
 *     TODO: Implement all app actions trough the ngrx store. This will give you the following benefits:
 *           - Complete overview of the state using the state graph
 *           - Actions replay, thus easy bug reporting
 *           - A good solid framework to work with state
 * <!> It is not necessary to reingeneer the whole app to implement the state store properly. Please contact the original author for additional info.
 * <!> Initially all the CSS style were written using traditional css. Meanwhile SASS was installed. Styles could be updated take advantage of SASS nesting of selectors.
 */
@Component({
    selector: 'app-cmp',
    template: require('./app.cmp.html'),
    styles: [String(require('./app.cmp.scss'))],
    host: { 'class': 'app' }
})
export class AppCmp {

    constructor (
        private _appService: AppService,
        private _productCategoriesMockApi: ProductCategoriesMockApi,
        private _appCatalogService: AppCatalogService,
        private _productsMockApi: ProductsMockApi,
        private _navigationService: NavigationService,
        private _logsService: LogsService
    ) {
        // 'Construct app component' );
    }

    ngOnInit () {
        // 'Initialise app component' );

        // App entry point
        this._appService.init();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/app.cmp.ts